import { createContext } from "react";

export const DocumentDetailContext = createContext(null);